export const LAND_LINE_OFFER = 'landlineOffer'
